// extracted by mini-css-extract-plugin
export default {"container":"fqYRt2rKylh5QXK2hipw","title":"lwHthD0TV0vTd86hZJsE","description":"ckMXLcRordwSYEYrqxcm","cardsGrid":"VvQLpvIvfYCeOmvcYgyF"};